var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animate-pulse shadow-sm rounded-md max-w-sm"},[_c('div',{staticClass:"w-full bg-gray-300 h-96"}),_c('div',{staticClass:"flex space-x-3 items-center h-16 justify-center"},[_c('div',{staticClass:"w-24 bg-gray-300 h-6 rounded-md"}),_c('div',{staticClass:"w-24 bg-gray-300 h-6 rounded-md"})])])
}]

export { render, staticRenderFns }